import Moment from "moment/moment";
import React from "react";

export const TABLE_COLUMN_MAIN_PAGE = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "tanggalInvoice",
        label: "Tanggal Invoice",
        options: {
            sort: false,
        },
    },
    {
        name: "dealerID",
        label: "Dealer ID",
        options: {
            sort: false,
        },
    },
    {
        name: "nomorKTP",
        label: "Nomor KTP",
        options: {
            sort: false,
        },
    },
    {
        name: "namaCustomer",
        label: "Nama Customer",
        options: {
            sort: false,
        },
    },
    {
        name: "alamat",
        label: "Alamat",
        options: {
            sort: false,
        },
    },
    {
        name: "kodeKota",
        label: "Kode Kota",
        options: {
            sort: false,
        },
    },
    {
        name: "kodeKecamatan",
        label: "Kode Kecamatan",
        options: {
            sort: false,
        },
    },
    {
        name: "kodeKelurahan",
        label: "Kode Kelurahan",
        options: {
            sort: false,
        },
    },
    {
        name: "kodeTipeUnit",
        label: "Kode Tipe Unit",
        options: {
            sort: false,
        },
    },
    {
        name: "kodeWarna",
        label: "Kode Warna",
        options: {
            sort: false,
        },
    },
    {
        name: "nomorRangka",
        label: "Nomor Rangka",
        options: {
            sort: false,
        },
    },
    {
        name: "nomorMesin",
        label: "Nomor Mesin",
        options: {
            sort: false,
        },
    },
]

export const config = {
    tableColumns: TABLE_COLUMN_MAIN_PAGE
}